export default "__VITE_ASSET__aZXdGHHs__"